import React, {useEffect, useMemo, useState} from 'react';
import {Link} from "react-router-dom";
import Api from "../../api/api";
import MaterialIcon from "react-google-material-icons";
import {ExportCSV} from "../Export/ExportTransactions";
import getRole from "../../getRole";

const Clients = ({noCreate}) => {
    const isGod = getRole() === 'god';
    const [managers, setManagers] = useState([])
    const [sortName, setSortName] = useState('')
    const [sortPhone, setSortPhone] = useState('')
    const [sortOlimp, setSortOlimp] = useState('')

    const filteredManagers = useMemo(() => {
        return managers.filter(manager => {
            if (!sortName.trim().length) {
                return manager;
            }
            if(manager) {
                if (isGod) {
                    return manager.fullname.toLowerCase().includes(sortName.trim().toLowerCase());
                } else {
                    return manager.name.toLowerCase().includes(sortName.trim().toLowerCase());
                }
            }
            return manager;
        }).filter(manager => {
            if ((isGod == false && sortPhone.trim().length<11)) {
                return manager;
            }
            if (!sortPhone.trim().length) {
                return manager;
            }
            return manager.login.includes(sortPhone.trim())
        }).filter(manager => {
            if (!sortOlimp.trim().length) {
                return manager;
            }
            if (manager.olimp_login !== null) {
                return manager.olimp_login.includes(sortOlimp.trim())
            }
        });
    }, [managers, sortName, sortPhone, sortOlimp]);

    const preparedClients = useMemo(() => {
        return filteredManagers.map((m) => {
            return {
                '#': m.id,
                'Имя': isGod ? m.fullname : m.name,
                'Телефон': '7******'+m.login.slice(-4),
                'Логин OlimpBet': m.olimp_login,
                'Баланс, freebee': m.balance.toFixed(2),
                'Баланс, тнг': (m.balance / 2.5).toFixed(2)
            };
        })
    }, [filteredManagers]);

    const getManagers = async () => {
        let { data } = await Api.clientsRead()
        setManagers(data.reverse())
    }
    useEffect(() => {
        (async () => {
            await getManagers();
        })();
    }, []);

    return (
        <>
            <h2>Пользователи</h2>
            {!noCreate && <Link to="/clientsCreate/">
                <div className="btn btn-success mt-15">Добавить</div>
            </Link>}
            <div className='mt-2'>
                <ExportCSV  csvData={preparedClients} fileName='Пользователи'/>
            </div>
            <br/>
            <div className="transaction-index mt-15">
                <div id="p0" data-pjax-container="" data-pjax-push-state data-pjax-timeout="1000">
                    <div id="w2" className="grid-view">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Имя</th>
                                <th>Номер</th>
                                <th>Логин OlimpBet</th>
                                {isGod && <th>Баланс</th>}
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>
                                    <input value={sortName} onChange={e => setSortName(e.currentTarget.value)} type="text" className="form-control" name="TransactionSearch[phone]"/>
                                </td>
                                <td>
                                    <input value={sortPhone} onChange={e => setSortPhone(e.currentTarget.value)} type="text" className="form-control" name="TransactionSearch[phone]"/>
                                </td>
                                <td>
                                    <input value={sortOlimp} onChange={e => setSortOlimp(e.currentTarget.value)} type="text" className="form-control" name="TransactionSearch[olimp_login]"/>
                                </td>
                            </tr>
                            </thead>
                            <tfoot>
                            </tfoot>
                            <tbody>
                            {managers.length ? filteredManagers.map(el => <TableItem key={el.id} isGod={isGod} {...el} />) : <p>Загрузка...</p>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
};

const TableItem = (props) => {
    return (
        <tr>
            <td>{props.id}</td>
            {props.isGod && <td>{props.fullname}</td>}
            {props.isGod == false && <td>{props.name} {props.surname.slice(0,1)}.</td>}
            <td>7********{props.login.slice(-4)}</td>
            <td>{props.olimp_login}</td>
            {props.isGod && <td>{props.balance} fb</td>}
            {props.isGod && <td>{props.balance / 2.5} тг.</td>}
            {props.isGod && <td>{props.cashback == 1 && "+"}</td>}
            {props.isGod && <td>{props.tengeback == 1 && "$"}</td>}
            <td>
                <Link to={`/clientsView/${props.id}`} title="Просмотр" aria-label="Просмотр"
                      data-pjax="0">
                    <MaterialIcon icon="remove_red_eye" size={18} />
                </Link>
            </td>
        </tr>
    );
}


export default Clients;
